var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1L0 15.5L1.5 38L20 48.5L36 53L50 32L50.5 15.5L41 6.5L27 0.5L13.5 1Z",
    fill: "#011F62"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 6.5L30.6456 14.3485L25.7701 26.653L28.6954 44.4759L23.0771 40.8218L19.9197 49L1.5 38L0 15.4423L13.2797 1L27 0.5L41 6.5Z",
    fill: "#610051"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53L28.9732 44.0665L27.4065 30L20 48.558L36 53Z",
    fill: "#0856A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15L5 35.5L21 44.7185L19.4161 49L1.5 38L0 15Z",
    fill: "#0856A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8253 19.4283C34.682 19.659 35.3574 20.3344 35.5881 21.1911C36.0164 22.7562 35.9999 26.0181 35.9999 26.0181C35.9999 26.0181 35.9999 29.2635 35.5881 30.8286C35.3574 31.6853 34.682 32.3607 33.8253 32.5914C32.2602 33.0032 26 33.0032 26 33.0032C26 33.0032 19.7562 33.0032 18.1746 32.5749C17.318 32.3443 16.6425 31.6688 16.4119 30.8121C16 29.2635 16 26.0016 16 26.0016C16 26.0016 16 22.7562 16.4119 21.1911C16.6425 20.3344 17.3344 19.6425 18.1746 19.4119C19.7397 19 26 19 26 19C26 19 32.2602 19 33.8253 19.4283ZM29.2124 26.0016L24.0065 28.9999V23.0033L29.2124 26.0016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f64841cdf98633d7a2a9c4e426f9ce3f.svg";
export { ForwardRef as ReactComponent };